import React from "react";

const contentMap = {
  questions: {
    title: "NEET Questions Bank",
    desc: "Practice thousands of NEET UG & PG previous year questions with detailed solutions.",
    features: ["PYQs", "Topic-wise Practice", "Solutions", "Difficulty Levels"]
  },
  testSeries: {
    title: "Test Series",
    desc: "Attempt full-length mock tests and improve your rank with real exam experience.",
    features: ["Mock Tests", "All India Rank", "Performance Analysis", "Time Tracking"]
  },
  courses: {
    title: "Courses",
    desc: "Comprehensive NEET courses designed by experts to boost your preparation.",
    features: ["Video Lectures", "Notes", "Doubt Support", "Revision Plans"]
  },
   settings: {
    title: "Account Settings",
    desc: "Manage your profile, security, and application preferences.",
    features: [
      "Profile Update",
      "Coustomer Support",
      "Notification Settings",
      "Privacy Controls"
    ]
  }
};

export default function ComingSoon({ type = "questions" }) {
  const data = contentMap[type];

  return (
    <div style={styles.container}>
    

      <div style={styles.card}>
        <h2 style={styles.brand}>NEET Ranker</h2>

        <h1 style={styles.title}>
          {data.title} <br />
          <span style={{ color: "#6366f1" }}>Coming Soon</span>
        </h1>

        <p style={styles.subtitle}>{data.desc}</p>

        <div style={styles.features}>
          {data.features.map((f, i) => (
            <span key={i} style={styles.featureItem}>
              ✔ {f}
            </span>
          ))}
        </div>

        <div style={styles.loader}>
          <div style={{ ...styles.dot, animationDelay: "0s" }}></div>
          <div style={{ ...styles.dot, animationDelay: "0.2s" }}></div>
          <div style={{ ...styles.dot, animationDelay: "0.4s" }}></div>
        </div>
      </div>

      {/* Animation */}
      <style>
        {`
          @keyframes bounce {
            0%, 80%, 100% { transform: scale(0); }
            40% { transform: scale(1); }
          }
        `}
      </style>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    width: "100%",
    background: "linear-gradient(135deg, #0f172a, #020617)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
    fontFamily: "Inter, sans-serif",
    padding: "15px",
  },


  card: {
    zIndex: 2,
    textAlign: "center",
    padding: "clamp(20px, 5vw, 50px)",
    borderRadius: "20px",
    background: "rgba(255,255,255,0.05)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255,255,255,0.1)",
    maxWidth: "600px",
    width: "100%",
  },

  brand: {
    color: "#6366f1",
    marginBottom: "10px",
    letterSpacing: "2px",
    fontSize: "clamp(14px, 3vw, 18px)",
  },

  title: {
    fontSize: "clamp(26px, 6vw, 48px)",
    fontWeight: "bold",
    color: "#fff",
    marginBottom: "20px",
    lineHeight: "1.3",
  },

  subtitle: {
    color: "#94a3b8",
    lineHeight: "1.6",
    marginBottom: "25px",
    fontSize: "clamp(13px, 3.5vw, 16px)",
  },

  features: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    flexWrap: "wrap",
    marginBottom: "25px",
  },

  featureItem: {
    color: "#cbd5f5",
    fontSize: "clamp(12px, 3vw, 14px)",
    background: "rgba(255,255,255,0.05)",
    padding: "6px 10px",
    borderRadius: "8px",
  },

  loader: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
  },

  dot: {
    width: "10px",
    height: "10px",
    background: "#6366f1",
    borderRadius: "50%",
    animation: "bounce 1.4s infinite ease-in-out",
  },
};